"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _molecules = require("../../molecules");

var _Icons = require("../../atoms/Icons");

var _classnames = _interopRequireDefault(require("classnames"));

var _SidebarModule = _interopRequireDefault(require("./Sidebar.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Sidebar(props) {
  var items = props.items,
      activeRoute = props.activeRoute,
      onChangeRoute = props.onChangeRoute,
      children = props.children,
      closeMenuLabel = props.closeMenuLabel,
      _props$initialExpande = props.initialExpanded,
      initialExpanded = _props$initialExpande === void 0 ? true : _props$initialExpande,
      _props$hideMenu = props.hideMenu,
      hideMenu = _props$hideMenu === void 0 ? false : _props$hideMenu;

  var _useState = (0, _react.useState)(initialExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      expand = _useState2[1];

  var _useState3 = (0, _react.useState)(36),
      _useState4 = _slicedToArray(_useState3, 2),
      distanceToTop = _useState4[0],
      setDistanceToTop = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      sticky = _useState6[0],
      setSticky = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      timer = _useState8[0],
      setTimer = _useState8[1];

  var _useState9 = (0, _react.useState)(initialExpanded),
      _useState10 = _slicedToArray(_useState9, 2),
      labelVisible = _useState10[0],
      setLabelVisible = _useState10[1];

  var active = (0, _get2.default)(activeRoute, 'general.route');
  var ref = (0, _react.useRef)(null);
  var sideBarRef = (0, _react.useRef)(null);
  var handleScroll = (0, _react.useCallback)((0, _debounce.default)(function () {
    if (!sideBarRef.current) return;
    setDistanceToTop(sideBarRef.current.getBoundingClientRect().top);
  }, 350), [sideBarRef]);
  (0, _react.useEffect)((0, _debounce.default)(function () {
    if (!sideBarRef.current) return;
    setDistanceToTop(sideBarRef.current.getBoundingClientRect().top);
  }, 350), [sideBarRef]);
  (0, _react.useEffect)(function () {
    if (!ref.current) return;
    var observer = new IntersectionObserver(function (entries) {
      setSticky(!entries[0].intersectionRatio);
    }, {
      threshold: [0, 1]
    });
    observer.observe(ref.current);

    if (!sticky) {
      window.addEventListener('scroll', handleScroll);
    } // eslint-disable-next-line consistent-return


    return function () {
      observer.disconnect();

      if (!sticky) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [expanded]);
  var handleExpand = (0, _react.useCallback)(function () {
    var next = !expanded;
    expand(next);

    if (next) {
      if (timer) {
        clearTimeout(timer);
      } else {
        var newTimer = setTimeout(function () {
          setTimer(null);
          setLabelVisible(true);
        }, 100);
        setTimer(newTimer);
      }
    } else {
      clearTimeout(timer);
      setTimer(null);
      setLabelVisible(false);
    }
  }, [expand, expanded]);
  var closeClassName = (0, _classnames.default)('flex flex-row text-center flex-nowrap', 'py-3 pointer transition-padding cursor-pointer text-white absolute bottom-3', expanded ? 'left-5 px-6 justify-center' : 'left-3 justify-start transform rotate-180');
  var iconClassName = (0, _classnames.default)('inline-flex rounded-md justify-center items-center font-normal fill-white', expanded ? 'pr-4' : 'ml-3');
  var sidebarClassName = (0, _classnames.default)('bg-auxiliar-blue relative pt-10', expanded ? "w-60 min-w-60 ".concat(_SidebarModule.default.sidebar__expanded) : 'w-12 min-w-12', sticky && 'sticky top-0');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row"
  }, !hideMenu && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    style: {
      height: 0,
      backgroundColor: 'red'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: sideBarRef,
    className: sidebarClassName,
    style: {
      height: !sticky ? "calc(100vh - ".concat(distanceToTop, "px)") : '100vh'
    }
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "nav flex-column sidebar-list"
  }, items.map(function (item) {
    var label = item.label;
    return /*#__PURE__*/_react.default.createElement(_molecules.SidebarItem, {
      key: label,
      item: item,
      expanded: expanded,
      onClick: onChangeRoute,
      active: active,
      labelVisible: labelVisible
    });
  }), /*#__PURE__*/_react.default.createElement("li", {
    key: "close",
    className: closeClassName,
    onClick: handleExpand
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: iconClassName
  }, /*#__PURE__*/_react.default.createElement(_Icons.HideMenu, {
    width: "1.5rem",
    height: "1.5rem"
  })), /*#__PURE__*/_react.default.createElement("span", null, expanded ? closeMenuLabel : ''))))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('px-10 py-4 w-full', expanded && !hideMenu && 'expanded')
  }, children));
}

Sidebar.propTypes = {
  activeRoute: _propTypes.default.object,
  onChangeRoute: _propTypes.default.func,
  children: _propTypes.default.any,
  items: _propTypes.default.array,
  closeMenuLabel: _propTypes.default.string,
  initialExpanded: _propTypes.default.bool,
  hideMenu: _propTypes.default.bool
};
var _default = Sidebar;
exports.default = _default;